<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div class="table-container" ref="tableContainer" @mousemove.passive="tableMove" @mouseleave="tableLeave">
    <template>
      <div class="icon-right icon" @click="changePage('right')" v-show="isAppenRight && btnContainer.right">
        <i class="iconfont icon-xiangyou"></i>
      </div>
      <div class="icon-left icon" @click="changePage('left')" v-show="isAppenLeft && btnContainer.left">
        <i class="iconfont icon-xiangzuo"></i>
      </div>
      <div class="icon-top icon" @click="changePage('top')" v-show="isAppenTop && btnContainer.top">
        <i class="iconfont icon-xiangshang"></i>
      </div>
      <div class="icon-bottom icon" @click="changePage('bottom')" v-show="isAppenBottom && btnContainer.bottom">
        <i class="iconfont icon-xiangxia"></i>
      </div>
    </template>
    <div class="table-header" v-if="config.isAppenRow">
      <table v-if="fixedMethods">
        <colgroup v-if="!fixedMethods">
          <col v-for="(col, index) in getColWidth" :key="index" :width="col.width" />
        </colgroup>
        <thead>
          <tr v-for="(headerRow, rowIndex) in processedHeaders" :key="rowIndex">
            <th v-if="rowIndex === 0" ref="headerInfo" :rowspan="columnHeaderRows" :colspan="rowHeaderCols" class="corner-header">
              <selectEdit v-if="isConfig">
                <i class="iconfont icon-bianji1" @click.stop="editTableTitleAndHeader('header')"></i>
                <i class="iconfont icon-a-shanchu2x" v-if="Boolean(config.headerInfo)" @click.stop="delConfig('headerInfo')"></i>
                <el-popover popper-class="table-t-popover" trigger="click" placement="bottom">
                  <template #reference>
                    <i class="iconfont icon-shaixuan2"></i>
                  </template>
                  <logoEdit v-model:columnFont="config.colTitleStyle" :isCard="true" />
                </el-popover>
              </selectEdit>
              <styleModule :parentCustomData="customData" v-if="config.headerInfo" :dataInfo="config.headerInfo.styleInfo" style="inset: 0;z-index: 0;" :bgSelect="config.headerInfo.bgSelect" />
            </th>
            <template v-for="(header, colIndex) in config.colNum">
              <template v-if="headerRow[colIndex]">
                <th :key="colIndex"  :colspan="headerRow[colIndex].colspan" :style="config.rowTitleStyle" :rowspan="headerRow[colIndex].rowspan" :ref="`row-${headerRow[colIndex].dataIndex}`" class="column-header">
                  <selectEdit v-if="isConfig">
                    <i class="iconfont icon-bianji1" @click.stop="editRow(header)"></i>
                    <i class="iconfont icon-a-shanchu2x" v-if="Boolean(config[`row-${header.dataIndex}`])" @click.stop="delConfig(`row-${header.dataIndex}`)"></i>
                    <el-popover popper-class="table-t-popover" trigger="click" placement="bottom">
                      <template #reference>
                        <i class="iconfont icon-shaixuan2"></i>
                      </template>
                      <logoEdit v-model:columnFont="config.rowTitleStyle" :isCard="true" />
                    </el-popover>
                  </selectEdit>
                  <styleModule :parentCustomData="customData" v-if="config[`row-${headerRow[colIndex].dataIndex}`]" :dataInfo="config[`row-${headerRow[colIndex].dataIndex}`].styleInfo" style="inset: 0;z-index: 0;" :bgSelect="config[`row-${headerRow[colIndex].dataIndex}`].bgSelect" />
                  {{ headerRow[colIndex].label }}
                </th>
              </template>
              <template v-else>
                <th :key="colIndex"></th>
              </template>
            </template>
            <th v-if="rowIndex === 0 && fixedMethods && scrollInfo.isScrollY" :rowspan="columnHeaderRows" :width="scrollInfo.scrollW"  style="background-color: #fff; padding: 0;box-sizing: border-box;"></th>
          </tr>
        </thead> 
      </table>
    </div>
    <div class="table-body-fixed" ref="tableBodyFixed" v-if="!fixedMethods" :style="{ width: `${100 * rowHeaderCols}px`, bottom: (scrollInfo.scrollW + 1) + 'px' }"> <!-- 加1 是因为表格的宽度要算进去 -->
      <table ref="tableBody">
        <colgroup>
          <col v-for="(col, index) in getColWidth" :key="index" :width="col.width" />
        </colgroup>
        <!-- 列表头区域 -->
        <thead>
          <tr v-for="(headerRow, rowIndex) in processedHeaders" :key="rowIndex">
            <th v-if="rowIndex === 0" ref="headerInfo" :rowspan="columnHeaderRows" :colspan="rowHeaderCols" class="corner-header">
              <selectEdit v-if="isConfig" @goEdit="editTableTitleAndHeader('header')" @goDel="delConfig('headerInfo')" :isAppenDel="Boolean(config.headerInfo)" />
              <styleModule :parentCustomData="customData" v-if="config.headerInfo" :dataInfo="config.headerInfo.styleInfo" style="inset: 0;z-index: 0;" :bgSelect="config.headerInfo.bgSelect" />
            </th>
            <th v-for="(header, colIndex) in headerRow" :key="colIndex" :colspan="header.colspan" :rowspan="header.rowspan" :ref="`row-${header.dataIndex}`" class="column-header">
              <selectEdit v-if="isConfig" @goEdit="editRow(header)" @goDel="delConfig(`row-${header.dataIndex}`)"  :isAppenDel="Boolean(config[`row-${header.dataIndex}`])" />
              <styleModule :parentCustomData="customData" v-if="config[`row-${header.dataIndex}`]" :dataInfo="config[`row-${header.dataIndex}`].styleInfo" style="inset: 0;z-index: 0;" :bgSelect="config[`row-${header.dataIndex}`].bgSelect" />
              {{ header.label }}
            </th>
          </tr>
        </thead>
        <!-- 数据区域 -->
        <tbody>
          <tr v-if="isAppenAll">
            <th :rowspan="1" class="row-header" :colspan="rowHeaderCols">全部</th>
            <td v-for="(col, colIndex) in leafColumns" :key="'cell-' + colIndex" class="data-cell">
              <Options :key="dataKey" :optionsConfig="config.cellConfig && config.cellConfig[`${rowIndex}-${colIndex}`]" />
            </td>
          </tr>
          <tr v-for="(row, rowIndex) in processedRows" :key="rowIndex">
            <!-- 列表头 -->
            <th v-for="(header, colIndex) in row.headers" :key="'header-' + colIndex" :rowspan="header.rowspan" :colspan="header.colspan" class="row-header">
              {{ header.label }}
            </th>
            <!-- 数据单元格 -->
            <td v-for="(col, colIndex) in leafColumns" :key="'cell-' + colIndex" class="data-cell">
              <Options :key="dataKey" :optionsConfig="config.cellConfig && config.cellConfig[`${rowIndex}-${colIndex}`]" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="table-body-wrapper" @scroll="handleScroll" ref="tableBodyWrapper">
      <table ref="tableBody" style="height: 100%;">
        <colgroup v-if="!fixedMethods">
          <col v-for="(col, index) in getColWidth" :key="index" :width="col.width" />
        </colgroup>
        <!-- 列表头区域 -->
        <thead :style="{ display: fixedMethods ? 'none' : '' }">
          <tr v-for="(headerRow, rowIndex) in processedHeaders" :key="rowIndex">
            <th v-if="rowIndex === 0" ref="headerInfo" :rowspan="columnHeaderRows" :colspan="rowHeaderCols" class="corner-header">
              <selectEdit v-if="isConfig" @goEdit="editTableTitleAndHeader('header')" @goDel="delConfig('headerInfo')" :isAppenDel="Boolean(config.headerInfo)" />
              <styleModule :parentCustomData="customData" v-if="config.headerInfo" :dataInfo="config.headerInfo.styleInfo" style="inset: 0;z-index: 0;" :bgSelect="config.headerInfo.bgSelect" />
            </th>
            <th v-for="(header, colIndex) in headerRow" :key="colIndex" :colspan="header.colspan" :rowspan="header.rowspan" :ref="`row-${header.dataIndex}`" class="column-header">
              <selectEdit v-if="isConfig" @goEdit="editRow(header)" @goDel="delConfig(`row-${header.dataIndex}`)"  :isAppenDel="Boolean(config[`row-${header.dataIndex}`])" />
              <styleModule :parentCustomData="customData" v-if="config[`row-${header.dataIndex}`]" :dataInfo="config[`row-${header.dataIndex}`].styleInfo" style="inset: 0;z-index: 0;" :bgSelect="config[`row-${header.dataIndex}`].bgSelect" />
              {{ header.label }}
            </th>
          </tr>
        </thead>
        <!-- 数据区域 -->
        <tbody ref="tableBody">
          <tr v-if="isAppenAll">
            <th :rowspan="1" class="row-header" v-if="config.isAppenCol" :colspan="rowHeaderCols">全部</th>
            <td v-for="(col, colIndex) in config.colNum" :key="'cell-' + colIndex" class="data-cell">
            </td>
          </tr>
          <tr v-for="(row, rowIndex) in config.rowNum" :key="rowIndex" ref="tableRow">
            <!-- 列表头 -->
            <template v-if="processedRows[rowIndex]">
              <template v-for="(header, colIndex) in processedRows[rowIndex].headers" :key="'header-' + colIndex">
                <th v-if="config.isAppenCol" :style="[config.colTitleStyle, { padding: header.key && header.key.includes('relation-user') ? '0 12px 0 0' : '' }]" :rowspan="header.rowspan" :colspan="header.colspan" class="row-header">
                  <template v-if="header.key && header.key.includes('relation-user')">
                    <userAppen style="padding-left: 12px;" :config="config" :info="header" />
                  </template>
                  <template v-else>
                    {{ header.label }}
                  </template>
                </th>
              </template>
              <!-- 数据单元格 -->
              <td v-for="(col, colIndex) in config.colNum" :key="'cell-' + colIndex" class="data-cell">
                <selectEdit @goEdit="goEditCustomRow(rowIndex, colIndex)" v-if="isConfig" />
                <Options :key="dataKey" @change="handleChange" :valueKey="`${rowIndex}-${colIndex}`" :optionsConfig="config.cellConfig && config.cellConfig[`${rowIndex}-${colIndex}`]" />
              </td>
            </template>
            <template v-else>
              <th v-if="config.isAppenCol" :rowspan="1" class="row-header" :colspan="rowHeaderCols"></th>
              <td v-for="(col, colIndex) in config.colNum" :key="'cell-' + colIndex" class="data-cell">
                <selectEdit @goEdit="goEditCustomRow(rowIndex, colIndex)" v-if="isConfig" />
                <Options :key="dataKey" @change="handleChange" :valueKey="`${rowIndex}-${colIndex}`" :optionsConfig="config.cellConfig && config.cellConfig[`${rowIndex}-${colIndex}`]" />
              </td>
            </template>
          </tr>
        </tbody>
      </table>
    </div>
    <reviseConfig ref="reviseConfig" :isAppenControl="true" :isCustomOpt="true" @reviseSave="reviseSave" />
  </div>
</template>
  
<script>
import selectEdit from '../common/selectEdit.vue';
import styleModule from '@/components/schoolInstrument/common/styleModule.vue'
import Options from '../common/customOptions.vue'
import userAppen from './userAppen.vue'
import { getMaxDepth, processedCols, processedRows } from '../utils'
import { isConditionAppen } from '@/components/schoolInstrument/component/mutual/common/config.js'
import { getScrollbarWidth } from '@/components/schoolInstrument/mixins/utils'
import reviseConfig from '@/components/admins/instrument/common/reviseConfig/index.vue'
import logoEdit from '@/components/common/logoEdit.vue'
export default {
  name: 'customTable',
  props: {
    config: {
      type: Object,
      default: () => ({})
    },
    columns: {
      type: Array,
      default: () => []
    },
    rows: {
      type: Array,
      default: () => []
    },
    isAppenAll: {
      type: Boolean,
      default: false
    },
    customData: {
      type: Array,
      default: () => []
    },
    isConfig: {
      type: Boolean,
      default: true
    },
    idx: {
      type: Number,
    },
    btnContainer: {
      type: Object,
      default: () => ({})
    },
    rowLen: {
      type: Number,
      default: 1
    },
    pageInfo: {
      type: Object,
      default: ()=>({})
    },
    allRows: {
      type: Array,
      default: () => []
    },
    queryData: {
      type: Object,
      default: () => ({})
    },
    appInfo: {
      type: Object,
      default: () => ({})
    },
  },
  components: {
    selectEdit,
    styleModule,
    Options,
    userAppen,
    reviseConfig,
    logoEdit
  },
  data() {
    return {
      tableData: {},
      scrollInfo: {
        isScrollY: false,
        scrollW: 0,
        isScrollX: false,
      },
      isAppenBottom: false,
      isAppenTop: false,
      isAppenLeft: false,
      isAppenRight: false,
      temporKey: -1,
      dataKey: 0,
    }
  },
  computed: {
    getColWidth() {
      const headerCol = new Array(this.rowHeaderCols).fill({ width: '100px' })
      const dataCol = new Array(this.leafColumns.length).fill({ width: '200px'})
      return [...headerCol, ...dataCol]
    },
    // 是否显示固定列
    fixedMethods() {
      const pageChange = this.config.pageChange
      this.getScrollInfo()
      return pageChange === 'roll'
    },
    // 处理列表头
    processedHeaders() {
      if (!this.columns.length) {
        return [{}]
      }
      const header = processedCols(this.columns)
      return header
    },
    // 获取叶子节点列
    leafColumns() {
      const leaves = []
      const getLeaves = (node) => {
        if ((node.children && !node.children.length) || !node.children) leaves.push(node)
        else node.children.forEach(child => getLeaves(child))
      }
      this.columns.forEach(child => getLeaves(child))
      return leaves
    },
    // 处理行表头
    processedRows() {
      const rows = processedRows(this.rows)
      return rows
    },
    processedAllRows() {
      const rows = processedRows(this.allRows)
      return rows
    },
    // 计算列表头的行数
    columnHeaderRows() {
      return this.processedHeaders.length
    },
    // 计算行表头的列数
    rowHeaderCols() {
      const obj = { children: this.rows }
      return getMaxDepth(obj) - 1 // 减1是因为跳过根节点
    },
    rowDefaultVal(){
      const rowInfo = this.config.rowInfo
      if (rowInfo.headerConfg) {
        if (rowInfo.headerConfg.screenLevel && rowInfo.headerConfg.screenLevel.levelNum === 1) {
          const value = rowInfo.headerConfg.value[0]
          const idx = this.columns.findIndex(item => item.value === value)
          return idx + ''
        } else {
          return ''
        }
      } else {
        return ''
      }
    }
  },
  methods: {
    reviseSave(value) {
      if (this.temporKey !== -1) {
        // eslint-disable-next-line vue/no-mutating-props
        this.config.cellConfig[this.temporKey] = value
        this.temporKey = -1
      }
    },
    goScrollPos(idx) {
      const tableBody = this.$refs.tableBodyWrapper
      const rows = this.$refs.tableRow
      const row = rows[idx]
      if (row && tableBody) {
        const containerRect = tableBody.getBoundingClientRect();
        const rowRect = row.getBoundingClientRect();
        const scrollTop = rowRect.top - containerRect.top + tableBody.scrollTop
        tableBody.scrollTo({
          top: scrollTop,
          behavior: 'smooth'
        })
      }
      
    },
    goEditCustomRow(rowIdx, colIdx) {
      const key = `${rowIdx}-${colIdx}`
      this.temporKey = key
      if (this.config.cellConfig === undefined) {
        // eslint-disable-next-line vue/no-mutating-props
        this.config.cellConfig = {}
      }
      let config = this.config.cellConfig[key]
      if (!config) {
        config = {
          type: 'pick',
          config: [],
          defaultVal: ''
        }
      }
      const customData = this.customData || []
      let allDatas = []
      if (this.appInfo.fieldList) {
        allDatas = this.appInfo.fieldList.filter(item => ['radio', 'checkbox', 'text', 'textarea', 'number'].includes(item.type))
      }
      this.$refs.reviseConfig.open(config, allDatas, customData)
    },
    handleChange({ value, valueKey }) {
      if (valueKey) {
        this.tableData[valueKey] = value
      }      
    },
    tableMove(e) {
      if (e.target.className === 'icon-right icon' || e.target.className === 'iconfont icon-xiangyou') {
        this.isAppenRight = true
        return
      }
      const { layerX: clientX, clientY } = e
      const target = this.$refs.tableContainer
      const { height, width } = target.getBoundingClientRect()
      
      if (clientX > width - 360) {
        this.isAppenRight = true
        this.isAppenLeft = false
      } else if (clientX < 360) {
        this.isAppenLeft = true
        this.isAppenRight = false
      }
      if (clientY > height - 300) {
        this.isAppenBottom = true
        this.isAppenTop = false
      } else if (clientY < 300) {
        this.isAppenBottom = false
        this.isAppenTop = true
      }
    },
    tableLeave() {
      this.isAppenRight = false
      this.isAppenLeft = false
      this.isAppenBottom = false
      this.isAppenTop = false
    },
    changePage(type) {
      this.$emit('changePage', {
        type,
        idx: this.idx
      })
    },
    handleScroll(e) {
      if (this.fixedMethods) return
      const fixedRef = this.$refs.tableBodyFixed
      fixedRef.scrollTop = e.target.scrollTop
    },
    getScrollInfo() {
      const wrapperRef = this.$refs.tableBodyWrapper
      const tableRef = this.$refs.tableBody
      if (!wrapperRef && !tableRef) return
      const rect = wrapperRef.getBoundingClientRect()
      // 总的高度
      const bodyHeight = rect.height
      const bodyWidth = rect.width
      // 表格的高度
      const contentH = tableRef.offsetHeight
      const contentW = tableRef.offsetWidth
      const isScrollY = (contentH - 1) > bodyHeight
      const isScrollX = contentW > bodyWidth
      const scrollW = getScrollbarWidth()
      const scrollInfo = { isScrollY, scrollW, isScrollX }
      this.scrollInfo = scrollInfo
    },
    handleChangeAll(val, idx) {
      if (this.config.optionsMenthods === 'select') {
        this.tableData[this.pageInfo.col]['all'][idx] = val
      }
      if (this.config.optionsMenthods === 'radio') {
        for (const key in this.tableData[this.pageInfo.col]) {
          if (key !== 'all') {
            this.tableData[this.pageInfo.col][key] = val
          }
        }
      } else {
        for (const key in this.tableData[this.pageInfo.col]) {
          if (key !== 'all') {
            this.tableData[this.pageInfo.col][key][idx] = val
          }
        }
      }
    },
    delConfig(key) {
      this.$emit('delConfig', key)
    },
    isAppenBtn(val, rowIndex, colIndex) {
      const customData = this.queryData.paramsList || []
      if (rowIndex === undefined && colIndex === undefined) return isConditionAppen(val.condition, {}, true, customData) 
      const rowPath = this.processedRows[rowIndex].path || []
      const scope = {}
      for (const ele of rowPath) {
        if (ele.targetField) {
          const key = ele.targetField.title
          scope[key] = ele.value
        }
      }
      const processedHeaders = this.processedHeaders
      
      if (processedHeaders[processedHeaders.length - 1][colIndex]) {
        const dataIndex = processedHeaders[processedHeaders.length - 1][colIndex].dataIndex || ''
        const idxLi = dataIndex.split('')
        processedHeaders.forEach((process, processIdx) => {
          const data = process[idxLi[processIdx]]
          if (data.key) {
            const key = data.key.split('_')[0]
            scope[key] = data.value
          }
        })
      }      
      return isConditionAppen(val.condition, scope, true, customData) 
    },
    editRow(value) {
      const id = `row-${value.dataIndex}`
      const obj = {
        id
      }
      let ref = this.$refs[id]
      if (ref) {
        ref = ref[0]
        const react = ref.getBoundingClientRect()
        obj.react = react
      }
      this.$emit('editRow', obj)
    },
    editTableTitleAndHeader() {
      this.$emit('openEdit')
    },
    // 初始化表格数据
    initTableData(isClear = true) {
      console.log(isClear,'isClearisClear')
      if (isClear) {
        this.tableData = {}
        this.dataKey++
      }
      this.getScrollInfo()
    },
  },
  mounted() {
    this.initTableData()
  },
  watch: {
    'config.optionsMenthods': {
      handler() {
        this.initTableData()
      }
    },
    'config.optionsConfig': {
      handler() {
        this.initTableData()
      },
      deep: true
    },
    'config.singleColNum': {
      handler() {
        this.initTableData()
      },
      deep: true
    },
    'config.rowNum': {
      handler() {
        this.initTableData()
      },
      deep: true
    },
    'config.colNum': {
      handler() {
        this.initTableData()
      },
      deep: true
    },
    rowLen: {
      handler() {
        this.initTableData()
      }
    }
  }
}
</script>

<style scoped lang="scss">

.table-container {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  border: solid 1px #dfe6ec;
  border-right: none;
  border-bottom: none;
  &::after {
    content: '';
    position: absolute;
    background-color: #dfe6ec;
    z-index: 1;
    top: 0;
    right: 0;
    width: 1px;
    height: 100%;
  }
  &::before {
    content: '';
    position: absolute;
    background-color: #dfe6ec;
    z-index: 1;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 1px;
  }

  ::v-deep .style-module {
    overflow: hidden;
  }
  .page-cutting {
    width: 100%;
    position: absolute;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 20;
    .icon {
      opacity: 0;
      visibility: hidden;
    }
    &:hover {
      .icon {
        opacity: 1;
        visibility: visible;
      }
    }
  }

  .top-page-cutting {
    top: 0;
  }

  .left-page-cutting {
    height: 100%;
    width: 40px;
    left: 0;
  }

  .right-page-cutting {
    height: 100%;
    width: 40px;
    right: 0;
  } 
  .bottom-page-cutting {
    bottom: 0;
  }
  
  .icon {
    position: absolute;
    background-color: #D1D1D1;
    color: #fff;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    z-index: 20;
    cursor: pointer;
  }

  .icon-right {
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
  .icon-left {
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }

  .icon-top {
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }
  .icon-bottom {
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  .table-body-fixed {
    position: absolute;
    left: 0;
    top: 0;
    overflow: hidden;
    box-sizing: border-box;
    z-index: 3;
  }

  .table-header {
    position: sticky;
    top: 0;
    z-index: 2;
    background: #fff;
    table {
      width: 100%;
      border-collapse: collapse;
    }
  }
  .table-body-wrapper {
    flex: 1;
    overflow: auto;
    table {
      width: 100%;
      border-collapse: collapse;
    }
  }
}

table {
  border-collapse: collapse;
  width: 100%;
  background: #fff;
  table-layout: fixed; // 重要：确保列宽一致
}

th, td {
  padding: 12px;
  text-align: center;
  border-bottom: solid 1px #dfe6ec;
  border-right: solid 1px #dfe6ec;
}

th {
  background-color: #f5f7fa;
  font-weight: normal;
}

.corner-header {
  background-color: #f5f7fa;
  position: relative;
  .header-no-border {
    border-bottom: none;
  }
}

.column-header {
  position: relative;
}

.row-header {
  text-align: left;
  background-color: #f5f7fa;
  position: relative;
}

.data-cell {
  text-align: center;
  position: relative;
}

::v-deep .el-input {
  height: 32px;
  line-height: 32px;
  .el-input__inner {
    line-height: 32px;
    height: 100%;
  }
}

::v-deep .el-input-number {
  .el-input-number__decrease, .el-input-number__increase {
    height: 30px;
    line-height: 30px;
  }
}

.xing-lll {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  cursor: pointer;
}
.xing {
    margin-right: 10px;
    color: #D8D8D8;
    font-size: 16px;
}
.xing-active {
    color: #FFD12F;
}

.pick-l {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  overflow: auto;
  ::v-deep .el-radio {
    margin-right: 8px;
  }
}
.pick-l-l {
  display: flex;
  align-items: center;
  margin-right: 16px;
  cursor: pointer;
  &:last-child {
    margin-right: 0;
  }
}
.pick-l-l-x {
  background-color: #FFFFFF;
  border: 1px solid #DDE0E6;
  width: 14px;
  min-width: 14px;
  height: 14px;
  border-radius: 50%;
  box-sizing: border-box;
}
.pick-l-l-n {
  color: #666666;
  font-weight: 400;
  font-size: 12px;
  margin-left: 6px;
}
.pick-l-active {
  .pick-l-l-x {
    border: 5px solid #4E86FF;
  }
}
</style>